module.exports = __webpack_public_path__ + "media/images/icon_list/file-a3a046751441824a1a7e6573809e157e.svg";